export default "__VITE_ASSET__DUnOzsXm__"